import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';

export const About1 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-1-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-1-stack">
          <div className="about-title">
            As a musician or an artist you know the current streaming system is
            broken
          </div>
          <Typography className="about-description">
            There are 100,000 records released on the Spotifies of this world
            every single day. Unfortunately, the vast majority of them will not
            find enough listeners to produce a feasible income for the artist.
          </Typography>
          <Typography className="about-footer">
            You know this, we know this.
          </Typography>
        </Stack>
      </div>
    </div>
  );
};
